import React, { ReactNode } from 'react';
import { styled } from "styled-components";

const StyledRow = styled.div`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    width: 100%;
`;

interface RowProps {
  children: ReactNode;
}

const Row: React.FC<RowProps> = ({ children }) => {
  return (
    <StyledRow>
      {children}
    </StyledRow>
  );
}

export default Row;
